<template>
  <div id="chart">
    <apexchart type="donut" height="240" :options="chartOptions" :series="chartOptions.series"></apexchart>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ['indicadores'],
  data: function () {
    return {
      series1: [2, 4, 5, 6],
      labels1: ["a", "b", "c", "d"],
    };
  },
  computed: {
    chartOptions: function () {
      return {
        colors: ["#1976D2", "#00BCD4", '#9b9b9b'],
        legend: {
          fontSize: "14px",
          fontFamily: "Helvetica, Arial",
          fontWeight: 400,
          itemMargin: {
            vertical: 10,
          },
          formatter: function (seriesName, opts) {
            return (
              '<div class="legend-info">' +
              "<span>" +
              seriesName +
              ": " +
              "</span>" +
              "<span>" +
              opts.w.globals.series[opts.seriesIndex] +
              "</span>" +
              "</div>"
            );
          },
        },
        dataLabels: {
          enabled: false,
        },
        labels: ["Hombres", "Mujeres", 'Sin especificar'],

        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "22px",
                  fontFamily: "Roboto",
                  color: "#dfsda",
                  offsetY: -10,
                },
                value: {
                  show: true,
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  color: undefined,
                  offsetY: 16,
                  formatter: function (val) {
                    return val;
                  },
                },
                total: {
                  show: true,
                  label: "Total",
                  color: "#373d3f",
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b;
                    }, 0);
                  },
                },
              },
            },
          },
        },
        series: [this.indicadores.masculino_total, this.indicadores.femenino_total, this.indicadores.sin_especificar_total],
      };
    },
  },
};
</script>